import { useState, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { api } from '../../../config';
import { getAuthToken } from '../../../auth/tokenvalidation';
import { buildRequestImprovementBulkPayloads } from '../utils/tenderEvaluationHelpers';

const postDmut = async (endpoint, body) => {
  const token = getAuthToken();
  if (!token) {
    toast.error('Authentication required. Please login again.');
    return false;
  }

  await axios.post(`${api.API_URL}/dmut/${endpoint}`, body, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  return true;
};

const useRequestImprovement = () => {
  const [isLoading, setIsLoading] = useState(false);

  const submitBulkImprovement = useCallback(
    async ({
      improvements = [],
      message,
      closingDateImprovement,
      onSuccess,
    }) => {
      const missingMitraId = improvements.some(
        entry => !String(entry?.procurementMitraId ?? entry?.id ?? '').trim()
      );
      if (missingMitraId) {
        toast.error(
          'Procurement mitra ID tidak ditemukan. Muat ulang data offer.'
        );
        return false;
      }

      const missingCounterId = improvements.some(
        entry =>
          entry?.kind === 'counter' &&
          !String(entry?.quantityIncotermCounterId ?? '').trim()
      );
      if (missingCounterId) {
        toast.error(
          'Counter incoterm ID tidak ditemukan. Muat ulang data offer.'
        );
        return false;
      }

      const payloads = buildRequestImprovementBulkPayloads({
        improvements,
        message,
        closingDateImprovement,
      });

      if (!payloads.length) {
        toast.error('No valid quantity incoterm selected.');
        return false;
      }

      setIsLoading(true);
      try {
        for (const { endpoint, body } of payloads) {
          const ok = await postDmut(endpoint, body);
          if (!ok) return false;
        }
        toast.success('Request improvement submitted successfully.');
        onSuccess?.();
        return true;
      } catch (err) {
        const errMessage =
          err?.response?.data?.message ||
          err?.message ||
          'Failed to submit request improvement.';
        toast.error(errMessage);
        return false;
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  return { submitBulkImprovement, isLoading };
};

export default useRequestImprovement;
